import { action } from 'easy-peasy';
import { ISetAvailableSheltersAction } from '../types';

const setAvailableShelters: ISetAvailableSheltersAction = action((state, payload) => {
  state.availableShelters = payload;
});

export default setAvailableShelters;
